if (typeof debounce === "undefined") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get("theme-header")) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
      this.mobileMenuItemOuterElements = document.querySelectorAll('.mobile-menu .mobile-menu-item-outer');
      this.initializedSliders = new Map(); // Track initialized sliders by parent index
    }
    connectedCallback() {
      this.header_section = document.querySelector(".header-section");
      this.menu = this.querySelector("#mobile-menu");
      this.toggle = this.querySelector(".mobile-toggle-wrapper");
      
      // Add new event listener for back arrow
      const backArrow = document.querySelector('.active-mobile-tab svg');
      if (backArrow) {
        backArrow.addEventListener('click', () => {
          const activeMobileTab = document.querySelector('.active-mobile-tab');
          if (activeMobileTab) {
            activeMobileTab.style.display = 'none';
          }
    
          // Show all mobile menu items
          this.mobileMenuItemOuterElements.forEach((item) => {
            item.style.display = 'block';
          });
    
          // Close all submenus
          const allSubmenus = this.menu.querySelectorAll('.mobile-menu .link-container');
          allSubmenus.forEach(submenu => {
            submenu.classList.remove('submenu-open');
            submenu.removeAttribute('open');
          });
        });
      }

      document.addEventListener("keyup", (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === "ESCAPE") {
            this.toggle.removeAttribute("open");
            this.toggle.classList.remove("active");
          }
        }
      });
      
      if (this.classList.contains("header-sticky--active")) {
        document.body.classList.add("header-sticky--active");
      }
      
      this.toggle
        .querySelector(".mobile-toggle")
        .addEventListener("click", (e) => {
          if (this.toggle.classList.contains("active")) {
            e.preventDefault();
            document.body.classList.remove("overflow-hidden");
            this.toggle.classList.remove("active");
            this.closeAnimation(this.toggle);
          } else {
            document.body.classList.add("overflow-hidden");
            setTimeout(() => {
              this.toggle.classList.add("active");
            });
          }
          window.dispatchEvent(new Event("resize.resize-select"));
          this.mobileMenuItemOuterElements.forEach((item) => {
            item.style.display = 'block';
          });
          const mobileMenuDetails = this.menu.querySelectorAll('details.link-container');
          mobileMenuDetails.forEach(details => {
            details.classList.remove('submenu-open');
            details.removeAttribute('open');
          });
          const activeMobileTab = document.querySelector('.active-mobile-tab');
          if (activeMobileTab) {
            activeMobileTab.style.display = 'none';
          }
        });

      // Sticky Header Class
      window.addEventListener("scroll", this.setStickyClass.bind(this), {
        passive: true,
      });

      // Mobile Menu offset
      window.addEventListener("scroll", this.setHeaderOffset.bind(this), {
        passive: true,
      });
      window.addEventListener("scroll", this.setHeaderHeight.bind(this), {
        passive: true,
      });

      window.dispatchEvent(new Event("scroll"));

      if (document.querySelector(".announcement-bar-section")) {
        window.addEventListener("scroll", this.setAnnouncementHeight(), {
          passive: true,
        });
        window.dispatchEvent(new Event("resize"));
      }

      // Buttons.
      this.menu
        .querySelectorAll("summary")
        .forEach((summary) =>
          summary.addEventListener("click", this.onSummaryClick.bind(this)),
        );
    }
    
    setStickyClass() {
      if (this.classList.contains("header-sticky--active")) {
        let h = this.getBoundingClientRect().top;
        if (h <= 0) {
          this.classList.add("is-sticky");
        } else {
          this.classList.remove("is-sticky");
        }
      }
    }
    
    setAnnouncementHeight() {
      const a_bar = document.querySelector(".announcement-bar-section");
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty(
        "--announcement-height",
        h + "px",
      );
    }
    
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty("--header-offset", h + "px");
    }
    
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty("--header-height", h + "px");
    }
    
    initializeMobileSliderForParent(parentIndex) {
      // Find the slider within the specific parent menu item
      const slider = document.querySelector(`.mega-productlist-main-sm[data-slider-parent="${parentIndex}"]`);
      
      if (slider && !this.initializedSliders.has(parentIndex) && !slider.classList.contains('flickity-enabled')) {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          if (!slider.classList.contains('flickity-enabled')) {
            new Flickity(slider, {
              cellAlign: 'left',
              imagesLoaded: true,
              contain: true,
              prevNextButtons: true,
              pageDots: false,
              autoPlay: false,
              draggable: true,
              friction: 0.8
            });
            this.initializedSliders.set(parentIndex, true);
            console.log(`Mobile slider initialized for menu item ${parentIndex}`);
          }
        }, 300);
      }
    }
    
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute("open");
      const hasMobileMenuClass = summaryElement.classList.contains('mobile-menu-item-outer');
      
      if (isOpen) {
        detailsElement.classList.remove("submenu-open");
      } else {
        detailsElement.classList.add("submenu-open");
        this.mobileMenuItemOuterElements.forEach((item) => {
          item.style.display = 'none';
        });
        
        if (hasMobileMenuClass) {
          const menuText = summaryElement.textContent.trim();
          const activeMobileText = document.querySelector('.active-mobile-text');
          const activeMobileTab = document.querySelector('.active-mobile-tab');
          
          if (activeMobileText && activeMobileTab) {
            activeMobileText.textContent = menuText;
            activeMobileTab.style.display = 'flex';
          } else if (activeMobileTab) {
            activeMobileTab.style.display = 'none';
          }
          
          // Get the parent index from the product wrapper
          const productWrapper = detailsElement.querySelector('.mega-nav-product-wrapper-mobile');
          if (productWrapper) {
            const parentIndex = productWrapper.getAttribute('data-parent-index');
            if (parentIndex) {
              this.initializeMobileSliderForParent(parentIndex);
            }
          }
        }
        
        // Auto-open first nested detail if exists
        const firstNestedDetail = detailsElement.querySelector('.link-container');
        if (firstNestedDetail) {
          firstNestedDetail.setAttribute('open', '');
          firstNestedDetail.classList.add('submenu-open');
        }
      }
    }
    
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
    }
    
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove("submenu-open");
      this.closeAnimation(detailsElement);
    }
    
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute("open");
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define("theme-header", ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */

if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll(
        ".thb-full-menu .menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu",
      );
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function () {
        window.addEventListener(
          "resize",
          debounce(function () {
            _this.resizeSubMenus();
          }, 100),
        );
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu",
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.getBoundingClientRect().left +
              sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}

// Initialization of the product slider inside the mega menu (DESKTOP)
window.addEventListener('load', function() {
  var sliders = document.querySelectorAll('.mega-productlist-main-lg');
  sliders.forEach(function(slider) {
    new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      imagesLoaded: true,
      pageDots: false,
      autoPlay: false,
      draggable: true,
      friction: 0.8
    });
  });
});